// Turns a failed POST /common/kyc/verify-bank into what the bank details page shows.
//
// The backend sends { error_code, message, request_id }. error_code picks the
// translated message; message is the English fallback for a code this build has
// no translation for; request_id is the reference support searches for in
// CloudWatch / the BankVerificationLog admin.
//
// Accepts either an AxiosError (any non-2xx, including 5xx, whose body is still
// read here) or a 2xx body with success: false.

const KEY_PREFIX = 'awaiting_account_details.errors.';
const GENERIC_KEY = `${KEY_PREFIX}verification_failed`;

export function getBankVerificationError(errorOrBody) {
  const data = errorOrBody?.response ? errorOrBody.response.data : errorOrBody;
  const body = data && typeof data === 'object' && !(data instanceof Error) ? data : {};

  const code = typeof body.error_code === 'string' ? body.error_code : null;
  return {
    messageKey: code ? `${KEY_PREFIX}${code}` : GENERIC_KEY,
    fallbackMessage: typeof body.message === 'string' ? body.message : undefined,
    requestId: body.request_id || undefined,
  };
}
